import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/announcements',
    name: 'Announcements',
    component: () => import('@/views/announcements/index.vue'),
    meta: {
      title: '公告管理',
      permission: 'announcement:manage'
    }
  }
]

export default routes
